import { extensionRepository } from '@/repositories/Index'

class ExtensionService {
	async getCpcGeneral(params: any) {
		const res = await extensionRepository.getCpcGeneral(params)
		return res
	}
	async getCpcAdOrder(params: any) {
		const res = await extensionRepository.getCpcAdOrder(params)
		return res
	}
	async getCompaginListFn(params: any) {
		const res = await extensionRepository.getCompaginList(params)
		return res
	}
	async getCampaignExtendDataFn(params: any) {
		const res = await extensionRepository.getCampaignExtendData(params)
		return res
	}
	async getCompaginButtonDisplay(params: any) {
		const res = await extensionRepository.getCompaginButtonDisplay(params)
		return res
	}
	async getJournalDetail(params: any) {
		const res = await extensionRepository.getJournalDetail(params)
		return res
	}

	async cpcStatusChange(params: any) {
		const res = await extensionRepository.cpcStatusChange(params)
		return res
	}
	async noticeCenterList(params: any) {
		const res = await extensionRepository.noticeCenterList(params)
		return res
	}
	async getRechargeRedPacketList(params: any) {
		const res = await extensionRepository.getRechargeRedPacketList(params)
		return res
	}
	async getDiagnosisInfo(params: any) {
		const res = await extensionRepository.getDiagnosisInfo(params)
		return res
	}
	async getDiagnosisFlow(params: any) {
		const res = await extensionRepository.getDiagnosisFlow(params)
		return res
	}
	async getHotelBindingNotice(params: any) {
		const res = await extensionRepository.getHotelBindingNotice(params)
		return res
	}
	async getAccountInfo(params: any) {
		const res = await extensionRepository.getAccountInfo(params)
		return res
	}
	async getAgencyCashRedPacketRatio(params: any) {
		const res = await extensionRepository.getAgencyCashRedPacketRatio(params)
		return res
	}

	async cpcTrafficCarCreate(params: any) {
		const res = await extensionRepository.cpcTrafficCarCreate(params)
		return res
	}

	async getActivityKinds(params: any) {
		const res = await extensionRepository.getActivityKinds(params)
		return res
	}

	async getHotelCampaignPeakDay(params: any) {
		const res = await extensionRepository.getHotelCampaignPeakDay(params)
		return res
	}

	async beforeCreateCheck(params: any) {
		const res = await extensionRepository.beforeCreateCheck(params)
		return res
	}

	async createPromotion(params: any) {
		const res = await extensionRepository.createPromotion(params)
		return res
	}

	async modifyPromotion(params: any) {
		const res = await extensionRepository.modifyPromotion(params)
		return res
	}

	async getCpsSuggestBid(params: any) {
		const res = await extensionRepository.getCpsSuggestBid(params)
		return res
	}

	async getCpsEstimatedCost(params: any) {
		const res = await extensionRepository.getCpsEstimatedCost(params)
		return res
	}

	async getCpcAdDetail(params: any) {
		const res = await extensionRepository.getCpcAdDetail(params)
		return res
	}

	async getHotelPeakDayCalendar(params: any) {
		const res = await extensionRepository.getHotelPeakDayCalendar(params)
		return res
	}

	//获取订阅消息配置
	async getSubscribeFn(params: any) {
		const res = await extensionRepository.getSubscribe(params)
		return res
	}

	//获取初始订阅提醒信息
	async getStartSubscribeFn(params: any) {
		const res = await extensionRepository.getStartSubscribe(params)
		return res
	}

	//新增订阅提醒配置
	async addSubscribeFn(params: any) {
		const res = await extensionRepository.addSubscribe(params)
		return res
	}
	
	//更新订阅消息配置
	async updateSubscribeFn(params: any) {
		const res = await extensionRepository.updateSubscribe(params)
		return res
	}
	
	async getCampaignAdOrderDetail(params: any) {
		const res = await extensionRepository.getCampaignAdOrderDetail(params)
		return res
	}

	async getHotelCampaignInsuranceConfig() {
		const res = await extensionRepository.getHotelCampaignInsuranceConfig()
		return res
	}

	async getCpcAdAssessmentCompleted(params: { orderSerialId: string }) {
		const res = await extensionRepository.getCpcAdAssessmentCompleted(params)
		return res
	}

	async getScenarioBidNewPageSwitch() {
		const res = await extensionRepository.getScenarioBidNewPageSwitch()
		return res
	}
}

export default ExtensionService
